import { Alert, AlertTitle, Grid, Paper, Snackbar } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux/es/exports";
import CustomDateField from "../CustomComponents/CustomDateField";
import CustomTextField from "../CustomComponents/CustomTextField";

const ChequeReturnInfo = (props) => {
  const formData = useSelector((state) => state.chequeReturn.data);
  return (
    <React.Fragment>
      <Paper
        sx={{
          padding: "0px 16px 8px 16px",
          marginBottom: "0px !important",
        }}
      >
        <h4>{"Cheque Details"}</h4>
        <Grid container rowSpacing={0} columnSpacing={1}>
          <Grid item xs={12} sm={6} md={4} lg={4} xl={4}>
            <CustomDateField
              type="Voucher Date"
              label="Voucher Date"
              variant="standard"
              disabled={true}
              value={formData.voucherDate}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={4} lg={4} xl={4}>
            <CustomTextField
              type="Branch Name"
              label="Branch Name"
              variant="standard"
              disabled={true}
              value={formData.branch}
            ></CustomTextField>
          </Grid>
          <Grid item xs={12} sm={6} md={4} lg={4} xl={4}>
            <CustomTextField
              type="Charset"
              label="Charset"
              variant="standard"
              disabled={true}
              value={formData.charset}
            ></CustomTextField>
          </Grid>
          <Grid item xs={12} sm={6} md={4} lg={4} xl={4}>
            <CustomTextField
              type="Drawee Bank"
              label="Drawee Bank"
              variant="standard"
              disabled={true}
              value={formData.draweeBank}
            ></CustomTextField>
          </Grid>
          <Grid item xs={12} sm={6} md={4} lg={4} xl={4}>
            <CustomTextField
              type="Drawee Bank Branch"
              label="Drawee Bank Branch"
              variant="standard"
              disabled={true}
              value={formData.draweeBankBranch}
            ></CustomTextField>
          </Grid>
          <Grid item xs={12} sm={6} md={4} lg={4} xl={4}>
            <CustomTextField
              type="Applicant Name"
              label="Applicant Name"
              variant="standard"
              disabled={true}
              value={formData.customerName}
            ></CustomTextField>
          </Grid>
          <Grid item xs={12} sm={6} md={4} lg={4} xl={4}>
            <CustomTextField
              type="Cheque Type"
              label="Cheque Type"
              variant="standard"
              disabled={true}
              value={formData.chequeType}
            ></CustomTextField>
          </Grid>
        </Grid>
      </Paper>
    </React.Fragment>
  );
};

export default ChequeReturnInfo;
